import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import {
  Button,
  Checkbox,
  ConfigProvider,
  DatePicker,
  Divider,
  Form,
  Input,
  InputNumber,
  message,
  Modal,
  Select,
} from 'antd';
import 'dayjs/locale/it';
import locale from 'antd/locale/it_IT';
import { v4 as uuidv4 } from 'uuid';
import { decode as base64_decode, encode as base64_encode } from 'base-64';

import { getStoredLanguage, setStoredLanguage, translations } from '../../helpers/i18n';
import { useHideFields } from '../../hooks/UseHideFields';
import { ApiCallGet } from '../../helpers/ApiCallGet';
import { API_PATH, APP_ROUTES_PATH, WHITE_LABEL_TENANT } from '../../helpers/Constants';
import { ApiCall } from '../../helpers/ApiCall';
import { Context } from '../../context';

import XerjoffConfigProvider from './XerjoffConfigProvider';
import { XerjoffENPrivacyPolicy } from './XerjoffEnPolicy';
import { XerjoffITPrivacyPolicy } from './XerjoffItPolicy';
import XerjoffLogo from './XerjoffLogo';

const { Option } = Select;
const dateFormat = 'DD/MM/YYYY';

function dateNum(num) {
  num = "0" + num.toString();
  return num.substr(-2);
}

// Componente per i campi condizionali
const ConditionalField = ({ hideFields, fieldName, children }) => {
  if (!hideFields || hideFields[fieldName]) {
    return null;
  }
  return children;
};

export default function XerjoffRegister(props) {
  const [messageApi, contextHolder] = message.useMessage();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [disable, setDisable] = useState(false);
  const [province, setProvince] = useState([]);
  const [regioni, setRegioni] = useState([]);
  const [comuni, setComuni] = useState([]);
  const [caps, setCaps] = useState([]);


  const [birthData, setBirthData] = useState("");
  const [provincia, setProvincia] = useState("");
  const [regione, setRegione] = useState("");
  const [comune, setComune] = useState("");
  const [cap, setCap] = useState("");
  const [form] = Form.useForm();

  const {
    smsActivation,
    registerPage,
    usePassword,
    deviceType,
    hideFields: hideFieldsString,
    reference,
    referral,
    appToken,
    language,
  } = useContext(Context);

  const navigate = useNavigate();
  const t = translations[language] || translations[getStoredLanguage()];
  
  // Utilizzo dell'hook per parsare hideFields una volta sola
  const hideFields = useHideFields(hideFieldsString);

  // Helper per controllare se un campo è visibile
  const isFieldVisible = (fieldName) => {
    return !hideFields || !hideFields[fieldName];
  };

  const changeData = (e) => {
    setBirthData(`${e.$y}-${dateNum(e.$M + 1)}-${dateNum(e.$D)}`);
  };

  const error = (e) => {
    messageApi.open({
      type: 'error',
      content: e,
    });
  };

  const load = () => {
    messageApi.open({
      type: 'loading',
      content: t.registerLoading || 'Registrazione in corso...',
      duration: 0,
    });
  };

  useEffect(() => {
    setStoredLanguage('EN');
    if (referral) return;
    if (localStorage.getItem(reference)) navigate(APP_ROUTES_PATH.SMART_CARD);
  }, []);

  const showModal = () => setIsModalOpen(true);
  const handleOk = () => setIsModalOpen(false);
  const handleCancel = () => setIsModalOpen(false);

  const register = (values) => {
    const body = {
      "token_user": "",
      "parameters": {
        "token_key": appToken,
        "reference": reference,
        "uid_device": uuidv4(),
        "platform": "Browser",
        "platform_version": "1.0",
        "last_coordinates": "",
        "device_model": deviceType ? deviceType : "-",
        "name": values.name || "-",
        "surname": values.surname || "-",
        "city": values.comune || "-",
        "address": values.address || "-",
        "zip_code": values.zip_code || "-",
        "punto_vendita":values.punto_vendita || "-",
        "province": values.provincia || "-",
        "region": values.region || "-",
        "fiscal_code": values.fiscal_code || "-",
        "lottery_code": values.lottery_code || "-",
        "state": "IT",
        "phone": values.phone ? values.phone.toString() : "123456789",
        "mobile": values.mobile ? values.mobile.toString() : "123456789",
        "email": values.email || "-",
        "password": values.password || values.email + appToken,
        "gender": values.gender || "Altro",
        "birth_data": birthData || "1980-01-01",
        "consent_marketing": values.consent_marketing ? "1" : "0",
        "consent_third_parties_marketing": values.consent_third_parties_marketing ? "1" : "0"
      }
    };

    (async () => {
      const res = await ApiCall(`${API_PATH.SMARTCARD_SET_CUSTOMER}/index.php?method=${values.sms_activation}`, JSON.stringify(body));

      if (!res.status) {
        localStorage.setItem(reference, JSON.stringify(res));
        if (referral) {
          window.open(base64_decode(referral) + `token_user=${res.apps_customers.token_user}&name=${res.apps_customers.name}&surname=${res.apps_customers.surname}&card=${res.apps_customers_cards[0].ean13}&token_key=${appToken}`, `_self`);
        } else {
          setTimeout(() => {
            window.location.href = 'https://info.xerjoff.com/public/m/store-subscription';
          }, 100);
        }
      } else {
        if (res.message == "not_enabled") {
          error(t.userNotEnabled || "Utente non abilitato");
        } else if (res.status == "Already registered" && usePassword) {
          (async () => {
            const res = await ApiCallGet(`${API_PATH.GET_CUSTOMER}/?{"token_key":"${appToken}","email":"${values.email}","uid_device":"","password":"${values.email}"}`);

            if (!res.status) {
              localStorage.setItem(reference, JSON.stringify(res));
              if (referral) {
                window.open(base64_decode(referral) + `token_user=${res.apps_customers.token_user}&name=${res.apps_customers.name}&surname=${res.apps_customers.surname}&card=${res.apps_customers_cards[0].ean13}&token_key=${appToken}`, `_self`);
              } else {
                setTimeout(() => {
                  window.location.reload();
                }, 100);
              }
            } else {
              setDisable(false);
              console.log(res);
              messageApi.destroy();
              error(t.invalidData || "Dati errati o utente non esistente");
            }
          })();
        } else {
          setDisable(false);
          messageApi.destroy();
          error(t.userAlreadyExists || "Utente già esistente");
        }
        console.log(res);
      }
    })();
  };

  // Scarico le regioni
  useEffect(() => {
    (async () => {
      const res = await ApiCall(`${API_PATH.GET_COMUNI}/`);
      if (res) {
        const regioniTemp = res.map(regione => ({
          label: regione,
          value: regione
        }));
        setRegioni(regioniTemp);
      }
    })();
  }, []);

  // Scarico le province
  useEffect(() => {
    if (!regione) return;
    (async () => {
      const res = await ApiCall(`${API_PATH.GET_COMUNI}/?regione=${regione}`);
      if (res) {
        const provinceTemp = res.map(provincia => ({
          label: `${provincia.provincia} - ${provincia.provincia_sigla}`,
          value: provincia.provincia_sigla
        }));
        setProvince(provinceTemp);
      }
    })();
  }, [regione]);

  // Scarico i comuni
  useEffect(() => {
    if (!provincia) return;
    (async () => {
      const res = await ApiCall(`${API_PATH.GET_COMUNI}/?provincia=${provincia}`);
      if (res) {
        const comuniTemp = res.map(comune => ({
          label: comune,
          value: comune
        }));
        setComuni(comuniTemp);
      }
    })();
  }, [provincia]);

  // Scarico i cap
  useEffect(() => {
    if (!comune) return;
    (async () => {
      const res = await ApiCall(`${API_PATH.GET_COMUNI}/?comune=${comune}`);
      if (res) {
        const capsTemp = res.map(cap => ({
          label: cap,
          value: cap
        }));
        setCaps(capsTemp);
      }
    })();
  }, [comune]);

  return (
    <XerjoffConfigProvider>
      {contextHolder}
      
      <div className='w-100 flex justify-center align-center xerjoff'>
        <div
          className='form-wrapper'
          style={{ margin: !registerPage.media && "0px" }}
        >
          {registerPage.body && (
            <div className='mb-20' dangerouslySetInnerHTML={{ __html: registerPage.body }} />
          )}

          <XerjoffLogo/>

          <Form
            form={form}
            name="register"
            className='register-form'
            onFinish={(e) => {
              register(e);
              load();
              setDisable(!disable);
            }}
            layout='vertical'
            scrollToFirstError
          >
            {/* CAMPI PERSONALI */}
            {isFieldVisible('name') && (
              <Form.Item
                name="name"
                label={t.registerName}
                rules={[
                  {
                    required: true,
                    message: t.registerNameRequired,
                  },
                ]}
              >
                <Input />
              </Form.Item>
            )}

            {isFieldVisible('surname') && (
              <Form.Item
                name="surname"
                label={t.registerSurname}
                rules={[
                  {
                    required: true,
                    message: t.registerSurnameRequired,
                  },
                ]}
              >
                <Input />
              </Form.Item>
            )}

            {isFieldVisible('birth_data') && (
              <Form.Item
                name="birth_data"
                label={t.registerBirthDate}
              >
                <ConfigProvider locale={locale}>
                  <DatePicker
                    placeholder={t.birthDatePlaceholder || 'Select date'}
                    format={dateFormat}
                    className='w-100'
                    onChange={changeData}
                  />
                </ConfigProvider>
              </Form.Item>
            )}

              <Form.Item
                name="punto_vendita"
                label={t.shopName}
                rules={[
                    {
                      required: true,
                      message: t.shopNameRequired,
                    },
                  ]}
                >
                  <Select placeholder={t.shopNamePlaceholder}>
                    <Option value="STORE-001">{t.turin}</Option>
                    <Option value="STORE-002">{t.milan}</Option>
                  </Select>
            </Form.Item>
            
            {/* EMAIL */}
            <Form.Item
              name="email"
              label={t.registerEmail}
              rules={[
                {
                  type: 'email',
                  message: t.emailInvalid,
                },
                {
                  required: true,
                  message: t.emailRequired,
                },
              ]}
            >
              <Input />
            </Form.Item>

            {/* PASSWORD */}
            {!usePassword && (
              <>
                <Form.Item
                  name="password"
                  label={t.registerPassword}
                  rules={[
                    {
                      required: true,
                      message: t.passwordRequired,
                    },
                  ]}
                  hasFeedback
                >
                  <Input.Password />
                </Form.Item>

                <Form.Item
                  name="confirm"
                  label={t.registerConfirmPassword}
                  dependencies={['password']}
                  hasFeedback
                  rules={[
                    {
                      required: true,
                      message: t.confirmPasswordRequired,
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue('password') === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error(t.passwordMismatch));
                      },
                    }),
                  ]}
                >
                  <Input.Password />
                </Form.Item>
              </>
            )}

            {/* MOBILE */}
            {isFieldVisible('mobile') && (
              <Form.Item
                name="mobile"
                label={t.registerMobile}
                rules={[
                  {
                    required: true,
                    message: t.registerMobileRequired,
                  },
                ]}
              >
                <InputNumber
                  style={{ width: '100%' }}
                  controls={false}
                />
              </Form.Item>
            )}

            {/* PHONE */}
            {isFieldVisible('phone') && (
              <Form.Item
                name="phone"
                label={t.registerPhone}
                rules={[
                  {
                    type: 'number',
                    required: true,
                    message: t.registerPhoneRequired,
                  },
                ]}
              >
                <InputNumber
                  style={{ width: '100%' }}
                  controls={false}
                />
              </Form.Item>
            )}

            {/* GENDER */}
            {isFieldVisible('gender') && (
              <Form.Item
                name="gender"
                label={t.registerGender}
                rules={[
                  {
                    required: true,
                    message: t.genderRequired,
                  },
                ]}
              >
                <Select placeholder={t.genderPlaceholder}>
                  <Option value="Uomo">{t.man}</Option>
                  <Option value="Donna">{t.woman}</Option>
                  <Option value="Altro">{t.other}</Option>
                </Select>
              </Form.Item>
            )}

            {/* LOTTERY CODE */}
            {isFieldVisible('lottery_code') && (
              <Form.Item
                name="lottery_code"
                label={t.registerLotteryCode}
              >
                <Input />
              </Form.Item>
            )}

            {/* FISCAL CODE */}
            {isFieldVisible('fiscal_code') && (
              <Form.Item
                name="fiscal_code"
                label={t.registerTaxCode}
              >
                <Input />
              </Form.Item>
            )}

            {/* ADDRESS */}
            {isFieldVisible('address') && (
              <>
                <Form.Item
                  name="region"
                  label={t.registerRegion}
                  rules={[
                    {
                      required: true,
                      message: t.regionRequired,
                    },
                  ]}
                >
                  <Select options={regioni} onChange={(e) => setRegione(e)} />
                </Form.Item>

                {province.length > 0 && (
                  <Form.Item
                    name="provincia"
                    label={t.registerProvince}
                    rules={[
                      {
                        required: true,
                        message: t.provinceRequired,
                      },
                    ]}
                  >
                    <Select options={province} onChange={(e) => setProvincia(e)} />
                  </Form.Item>
                )}

                {comuni.length > 0 && (
                  <Form.Item
                    name="comune"
                    label={t.registerCity}
                    rules={[
                      {
                        required: true,
                        message: t.cityRequired,
                      },
                    ]}
                  >
                    <Select options={comuni} onChange={(e) => setComune(e)} />
                  </Form.Item>
                )}

                {caps.length > 0 && (
                  <Form.Item
                    name="zip_code"
                    label={t.registerZipCode}
                    rules={[
                      {
                        required: true,
                        message: t.zipCodeRequired,
                      },
                    ]}
                  >
                    <Select options={caps} onChange={(e) => setCap(e)} />
                  </Form.Item>
                )}

                {cap && (
                  <Form.Item
                    name="address"
                    label={t.registerAddress}
                    rules={[
                      {
                        required: true,
                        message: t.addressRequired,
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                )}
              </>
            )}

            <Divider />

            {/* CONSENTI MARKETING */}
            {isFieldVisible('terms') && (
              <>
                <Form.Item
                  name="consent_marketing"
                  valuePropName="checked"
                >
                  <Checkbox>
                    {t.consentMarketingXerjoff}
                  </Checkbox>
                </Form.Item>

                <Form.Item
                  name="consent_third_parties_marketing"
                  valuePropName="checked"
                >
                  <Checkbox>
                    {t.consentMarketingThirdPartiesXerjoff}
                  </Checkbox>
                </Form.Item>
              </>
            )}

            {/* TERMS & CONDITIONS */}
            <Form.Item
              name="terms"
              valuePropName="checked"
              rules={[
                {
                  validator: (_, value) =>
                    value ? Promise.resolve() : Promise.reject(new Error(t.termsError)),
                },
              ]}
            >
              <Checkbox>
                {t.termsAgreementPrefix}{' '}
                <span onClick={showModal} className='color-blue'>
                  {t.termsAndConditionsLink}
                </span>
              </Checkbox>
            </Form.Item>

            {/* SMS ACTIVATION */}
            {smsActivation == "1" && isFieldVisible('phone') && (
              <Form.Item
                name="sms_activation"
                valuePropName="checked"
              >
                <Checkbox>
                  {t.smsActivationLabel}
                </Checkbox>
              </Form.Item>
            )}

            {/* SUBMIT BUTTON */}
            <Form.Item>
              <Button
                disabled={disable}
                shape='round'
                type="primary"
                block
                size='large'
                className='fs-20 bold mt-10'
                htmlType="submit"
              >
                {t.registerButton}
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>

      <Modal
        width={"1500px"}
        open={isModalOpen}
        onCancel={handleCancel}
        onOk={handleOk}
      >
        {language === 'IT' ? XerjoffITPrivacyPolicy() : XerjoffENPrivacyPolicy() }
      </Modal>
    </XerjoffConfigProvider>
  );
}